import styled from '@emotion/styled';

const Background = styled.div`
  background: linear-gradient(0deg, oklch(65% 0.3 29.62deg / 80%), oklch(65% 0.3 29.62deg / 0%) 75%),
    linear-gradient(60deg, oklch(96% 0.25 110.23deg / 80%), oklch(96% 0.25 110.23deg / 0%) 75%),
    linear-gradient(120deg, oklch(85% 0.36 144.24deg / 80%), oklch(85% 0.36 144.24deg / 0%) 75%),
    linear-gradient(180deg, oklch(89% 0.2 194.59deg / 80%), oklch(89% 0.2 194.18deg / 0%) 75%),
    linear-gradient(240deg, oklch(47% 0.32 264.05deg / 80%), oklch(47% 0.32 264.05deg / 0%) 75%),
    linear-gradient(300deg, oklch(70% 0.35 327.92deg / 80%), oklch(70% 0.35 327.92deg / 0%) 75%);
  color: #fff;
  min-height: 100vh;
  overflow: hidden;
  position: relative;
`;

export default Background;
